import React from 'react'
import Progress from 'antd/lib/progress'

import { ProgressColors } from '../section-header/styles'

interface Props {
  nps: number
}

function PieChart({ nps = 0 }: Props) {
  const chartColor =
    nps < 60
      ? ProgressColors.LOW
      : nps >= 90
      ? ProgressColors.HIGH
      : ProgressColors.MEDIUM

  const chartPercent = ((nps + 100) * 100) / 200
  return (
    <Progress
      format={() => <span style={{ color: chartColor }}>{`${nps}`}</span>}
      percent={chartPercent}
      strokeColor={chartColor}
      strokeWidth={11}
      type="circle"
    />
  )
}

export default PieChart
